import { Box, Group } from '@mantine/core';
import React, { useState, useRef, useEffect } from 'react';
import { FlagRating } from 'utils/constants';
import { FlagIcon } from './FlagIcon';
import { FlagIconReject } from './FlagIconReject';
import styles from './FlagToggle.module.scss';


const FlagToggle = ({size,onChange,status}) => {
  const [acceptFlag, setAcceptFlag] = useState(status === FlagRating.FLAG_SELECT?true:false);
  const [rejectFlag, setRejectFlag] = useState(status === FlagRating.FLAG_KILL?true:false);
  
  const ratingContainerRef = useRef(null);

  const flagSize = size === 'sm'?10:14;

  const getIconClass = (isSelected, isReject = false) => {
    if (isReject) {
      return isSelected ? styles.flagIconRejectSelected : styles.flagIconReject;
    }
    return isSelected ? styles.flagIconSelected : styles.flagIcon;
  }

  useEffect(() => {
    setAcceptFlag(status && status.toString() === FlagRating.FLAG_SELECT?true:false);
    setRejectFlag(status && status.toString() === FlagRating.FLAG_KILL?true:false);
  },[status])



  const selectedClass = getIconClass(acceptFlag, false);
  const rejectedClass = getIconClass(rejectFlag, true);

  const onAcceptClick = props => {
    if(!acceptFlag)setRejectFlag(false);
    setAcceptFlag(!acceptFlag);
    onChange(FlagRating.FLAG_SELECT);
  }

  const onRejectClick = props => {
    if(!rejectFlag)setAcceptFlag(false);
    setRejectFlag(!rejectFlag);
    onChange(FlagRating.FLAG_KILL);
  }

  return (
    <Box
      className={styles.ratingContainer}
      ref={ratingContainerRef}
    >
    
        {/* // const activeState = isHovered ? hoverActiveStar : activeFlag;

        // const showEmptyIcon = activeState === -1 || activeState < index + 1;

        // const isActiveRating = activeState !== 1;
        // const isRatingWithPrecision = activeState % 1 !== 0;
        // const isRatingEqualToIndex = Math.ceil(activeState) === index + 1;
        // const showRatingWithPrecision =
        //   isActiveRating && isRatingWithPrecision && isRatingEqualToIndex; */}

        
          <Box
            position={'relative'}
            className={styles.flagGroup}
          >
            {/* <Box
              sx={{
                width: showRatingWithPrecision ? `${(activeState % 1) * 100}%` : '0%',
                overflow: 'hidden',
                position: 'absolute',
                lineHeight:1,
              }}
            >
              <FilledIcon size={12} style={starStyle} />
            </Box> */}
            {/*Note here */}
            <Group gap={7} wrap="nowrap">
              <div className={styles.flagButton} onClick={onAcceptClick}><FlagIcon size={flagSize} className={selectedClass} /></div>
              <div className={styles.flagButton} onClick={onRejectClick}><FlagIconReject size={flagSize} className={rejectedClass} /></div>
              {/* {activeFlag ? <EmptyIcon fill="currentColor" strokeColor="currentColor" size={12} /> : <FilledIcon  fill={theme.colors.brand[4]} strokeColor={theme.colors.brand[4]} />} */}
            </Group>
          </Box>
       
      
    </Box>
  );
};

export default FlagToggle;